import { render, staticRenderFns } from "./SessionJoinModal.vue?vue&type=template&id=28d2eda6&scoped=true&"
import script from "./SessionJoinModal.vue?vue&type=script&lang=js&"
export * from "./SessionJoinModal.vue?vue&type=script&lang=js&"
import style0 from "./SessionJoinModal.vue?vue&type=style&index=0&id=28d2eda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2eda6",
  null
  
)

export default component.exports